import axios from 'axios';

const uri = process.env.REACT_APP_BACK_URL;

export const getBuytById = async (id) => {
	const { data } = await axios.get(`${uri}/api/compras/${id}`);

	return data;
};
